<script lang="ts" context="module">
  export type BaseRoute = {
    icon: ComponentType | null;
    name: string;
    external?: boolean;
    isAcceleratorRoute?: boolean;
    hidden?: boolean;
    class?: string;
    badgeCount?: number;
    customBadge?: ComponentType | null;
  };

  export type ActionRoute = BaseRoute & {
    action: () => void;
    path?: never;
  };

  export type PathRoute = BaseRoute & {
    path: string;
    action?: never;
  };

  export type Route = ActionRoute | PathRoute;
</script>

<script lang="ts">
  import { page } from '$app/stores';
  import { cn } from '$lib/utils/misc';
  import { sideNavOpen } from '$stores';
  import type { ComponentType } from 'svelte';
  import Badge from '../../Badge.svelte';

  export let route: Route;

  $: isActive = $page.url.pathname === route.path;
  $: isActiveAcceleratorRoute = isActive && route.isAcceleratorRoute;

  function handleClick() {
    $sideNavOpen = false;
    if (route.action) {
      route.action();
    }
  }
</script>

{#if route.path}
  <a
    href={route.path}
    target={route.external ? '_blank' : undefined}
    rel={route.external ? 'noopener noreferrer' : ''}
    class={cn(
      'text-gray-dark-11 hover:text-gray-dark-12 flex items-center justify-between px-4 py-1.5 text-sm font-normal leading-5',
      isActive ? 'bg-gray-dark-2 text-gray-dark-12 rounded' : '',
      route.class,
    )}
  >
    <div class="flex items-center gap-x-1.5">
      {#if route.icon}
        <svelte:component
          this={route.icon}
          class={cn('h-4 w-4', isActiveAcceleratorRoute ? 'text-orange-dark-10' : '')}
        />
      {/if}
      <span>{route.name}</span>
    </div>
    {#if route.badgeCount && route.badgeCount > 0}
      <Badge
        content={route.badgeCount.toString()}
        emphasis="high"
        class={cn('!h-4', route.badgeCount > 9 ? '!px-1' : '!aspect-square !px-0')}
      />
    {/if}
    {#if route.customBadge}
      <svelte:component this={route.customBadge} />
    {/if}
  </a>
{:else}
  <button
    on:click={handleClick}
    class={cn(
      'text-gray-dark-11 hover:text-gray-dark-12 flex items-center gap-x-1 px-4 py-1.5 text-sm font-normal leading-5',
      route.class,
    )}
  >
    {#if route.icon}
      <svelte:component this={route.icon} class="h-4 w-4" />
    {/if}
    <span>{route.name}</span>
  </button>
{/if}
